import { IsBoolean, IsInt, IsOptional, IsUUID, Min } from 'class-validator';
import { ConditionalPartial } from '../../../utils';
import { CreateProductRequestDto } from './create-product.request.dto';

/**
 * DTO for updating product fields
 * All fields are optional for partial updates
 */
export class UpdateProductRequestDto extends ConditionalPartial(CreateProductRequestDto) {
    /**
     * Target major version number for version upgrade
     * @example 3
     */
    @IsOptional()
    @IsInt()
    @Min(1)
    targetVersionMajor?: number;

    /**
     * Target minor version number for version upgrade
     * @example 0
     */
    @IsOptional()
    @IsInt()
    @Min(0)
    targetVersionMinor?: number;
    /**
     * User ID performing the update (for audit logging)
     * @example 'user-uuid'
     */
    @IsOptional()
    @IsUUID()
    userId?: string;
}
